import React, { useState, useEffect, useRef, useMemo } from 'react';
import axios, { apiFetch } from '../api/client';
import { getPortfolio } from '../api/private';
import { useUser } from '../context/UserContext';
import { Pie } from 'react-chartjs-2';
import Chart from 'react-apexcharts';
import { Chart as ChartJS, ArcElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Sparkles } from 'lucide-react';
import StockPurchase from '../pages/stockpurchase.js';
import OrderHistory from '../pages/orderhistory.js';
import dayjs from 'dayjs';
import LineChart from '../images/lineChart.png';
import PieChart from '../images/pieChart.png';
import WhiteLine from '../images/GraphWhiteLine.png';
 import ReactMarkdown from 'react-markdown';
import WhitePie from '../images/WhitePie.png';
import Up from '../images/changeUp.png';
import Down from '../images/changeDown.png';
import Flat from '../images/noChange.png';
  import remarkGfm from 'remark-gfm'
import './portfolio-mobile-fix.css';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from "react-router-dom";
function ThinkingIndicator() {
  return (
    <div className="thinkingText">
      thinking…
    </div>
  );
}

function PortfolioAiMark({ compact = false }) {
  return (
    <span className={`portfolioAiMark${compact ? ' portfolioAiMarkCompact' : ''}`} aria-hidden="true">
      <Sparkles size={15} strokeWidth={2} />
    </span>
  );
}
ChartJS.register(ArcElement);
const diversificationPalettes = [
  ['#5932ea', '#8065ef', '#a594f5', '#d5ccfb'],
  ['#ffad0d', '#ffc64d', '#ffdb8e', '#fff0c7'],
  ['#2f80ed', '#59a0f2', '#8abcf6', '#c7dffc'],
];

const portfolioExampleQuestions = [
  `What's the total value of my portfolio?`,
  `Which holding contributed most today?`,
  `Show my allocation by sector.`,
  `How much did I gain or lose yesterday?`,
  `What's the weighted P/E of my portfolio?`,
  `Which position has the highest beta?`,
  `List my top three gainers.`,
  `How did my portfolio perform last quarter?`,
];

const formatPortfolioChartValue = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '0.00';
  return number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const getMarketCapCategory = (marketCap) => {
  if (marketCap === null || marketCap === undefined || marketCap === '') return 'Unknown';
  const value = Number(marketCap);
  if (!Number.isFinite(value)) return 'Unknown';
  if (value >= 200000) return 'Mega cap';
  if (value >= 10000) return 'Large cap';
  if (value >= 2000) return 'Mid cap';
  if (value >= 300) return 'Small cap';
  return 'Micro cap';
};
const PortfolioDisplayPage = ({ authReady = true }) => {
  const [portfolio, setPortfolio] = useState({});
  const [linechartdataloaded, setLineChartDataLoaded] = useState(false);
  const [stockData, setStockData] = useState({});
  const [stockData2, setStockData2] = useState({});
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalPurchaseValue, setTotalPurchaseValue] = useState(0);
  const [sortColumn, setSortColumn] = useState('datetime');
  const [purchasePopUpVisible, setPurchasePopUpVisible] = useState(false);
    const [sortOrder, setSortOrder] = useState('asc');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  //const [totalProfit, setTotalProfit] = useState(0);
  const { user, isLoggedIn } = useUser();
  const [lastFetchTime, setLastFetchTime] = useState(0);
  const [rawPortfolio, setRawPortfolio] = useState({});
  const [portfolioStockMetadata, setPortfolioStockMetadata] = useState([]);
  const cooldownTime = 500; 
  const [firstRun, setFirstRun] = useState(true);
  const cacheRef = useRef({});
///////////////////////////////////////////////////// FRED api key: c1dd8522a44f48a2661ec65273652912
  const [isThinking, setIsThinking] = useState(false);
  const [showTypewriter, setShowTypewriter] = useState(false);
  const shownExamples = useMemo(
    () => [...portfolioExampleQuestions].sort(() => Math.random() - 0.5).slice(0, 3),
    []
  );

  const [messagesAI, setMessagesAI] = useState([
    { sender: 'sleuthAI', text: '👋 Hi! I’m an AI system. My answers can be inaccurate and are not investment advice. Do not share sensitive personal data. Ask me anything about your portfolio.' }
  ]);
  const [inputText, setInputText] = useState('');
  const chatEndRef = useRef(null);

  const handleSend = (q = inputText) => {
    const question = q.trim();
    if (!question) return;

    // Append user message
    setMessagesAI(prev => [...prev, { sender: 'user', text: question }]);
    setInputText('');
    setIsThinking(true);

    // Call AI
    handleAIResponse(question);
  };

  const handleAIResponse = async (question) => {
    // Build history
    const history = messagesAI
      .map(m => ({ role: m.sender === 'user' ? 'user' : 'assistant', content: m.text }))
      .slice(-6);

    const messages = [
      {
        role: 'system',
        content: 'You are PortfolioSleuth AI. Use the provided sortedData JSON to answer concisely.'
      },
      {
        role: 'user',
        name: 'sortedData',
        content: JSON.stringify(sortedData)
      },
      ...history,
      {
        role: 'user',
        content: question
      }
    ];

    try {
      const res = await apiFetch('https://stocksleuth.xyz:5000/api/chatAI', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages, useFunctions: false })
      });
      const { choices } = await res.json();
      const aiText = choices?.[0]?.message?.content || '🤖 (no reply)';

      setMessagesAI(prev => [...prev, { sender: 'sleuthAI', text: aiText }]);
    } catch (err) {
      console.error('Chat API error:', err);
      setMessagesAI(prev => [...prev, { sender: 'sleuthAI', text: '😞 Something went wrong.' }]);
    } finally {
      setIsThinking(false);
      setShowTypewriter(true);
      setTimeout(() => setShowTypewriter(false), 800);
    }
  };

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messagesAI]);




  const handleSort = (column) => {
    // Toggle the sorting order if the same column is clicked again
    setSortOrder((prevSortOrder) => (column === sortColumn ? (prevSortOrder === 'asc' ? 'desc' : 'asc') : 'asc'));
    setSortColumn(column);
  };

  const sortTable = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  const sortedPortfolio = Object.entries(portfolio).flatMap(([stock, purchases]) => 
    purchases.map((purchase, index) => {
      if (purchase.shares !== 0) {
        const currentPrice = stockData[stock]?.[index]?.currentPrice || 'N/A';
        const priceChange = currentPrice !== 'N/A' ? (currentPrice - purchase.purchasePrice).toFixed(2) : 'N/A';
        const totalProfit = currentPrice !== 'N/A' ? ((currentPrice - purchase.purchasePrice) * purchase.shares).toFixed(2) : 'N/A';
        const totalHolding = currentPrice !== 'N/A' ? (currentPrice * purchase.shares).toFixed(2) : 'N/A';
        const pl = currentPrice !== 'N/A' 
          ? ((currentPrice - purchase.purchasePrice) / purchase.purchasePrice * 100).toFixed(2) + '%' 
          : 'N/A';
        
        return {
  stock: stock,
  purchasePrice: purchase.purchasePrice,
  shares: purchase.shares,
  currentPrice: currentPrice,
  totalProfit: totalProfit,
  totalHolding: totalHolding,
  pl: pl,
};
      }
      return null;
    })
  ).filter(item => item !== null);

  const sortedData = sortedPortfolio.sort((a, b) => {
    if (sortConfig.key === null) return 0;
  
    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];
  
    // Handle 'N/A' as null for sorting purposes
    const aComparable = aValue === 'N/A' ? null : aValue;
    const bComparable = bValue === 'N/A' ? null : bValue;
  
    // If sorting by a percentage column (Pl), parse the values as numbers
    if (sortConfig.key === 'pl') {
      const aPl = aComparable !== null ? parseFloat(aComparable.replace('%', '')) : null;
      const bPl = bComparable !== null ? parseFloat(bComparable.replace('%', '')) : null;
      return (aPl - bPl) * (sortConfig.direction === 'ascending' ? 1 : -1);
    }
  
    // If sorting by numeric columns (e.g., totalHolding, totalProfit, shares), compare as numbers
    if (['totalHolding', 'totalProfit', 'shares'].includes(sortConfig.key)) {
      const aNumeric = aComparable !== null ? parseFloat(aComparable) : null;
      const bNumeric = bComparable !== null ? parseFloat(bComparable) : null;
      return (aNumeric - bNumeric) * (sortConfig.direction === 'ascending' ? 1 : -1);
    }
  
    // For string-based columns (e.g., stock name), compare as strings
    if (typeof aComparable === 'string' && typeof bComparable === 'string') {
      return aComparable.localeCompare(bComparable) * (sortConfig.direction === 'ascending' ? 1 : -1);
    }
  
    // Default to equality for unexpected cases
    return 0;
  });

  const diversificationData = useMemo(() => {
    const metadataBySymbol = new Map(
      portfolioStockMetadata.map((item) => [item.symbol, item])
    );

    const allocations = {
      industry: {},
      sector: {},
      marketCap: {},
    };

    Object.entries(portfolio).forEach(([symbol, purchases]) => {
      const metadata = metadataBySymbol.get(symbol) || {};
      const currentPrice = Number(stockData[symbol]?.[0]?.currentPrice);
      const positionValue = purchases.reduce((sum, purchase) => {
        const shares = Number(purchase.shares);
        const fallbackPrice = Number(purchase.purchasePrice);
        const price = Number.isFinite(currentPrice) ? currentPrice : fallbackPrice;
        return sum + (Number.isFinite(shares) && Number.isFinite(price) ? shares * price : 0);
      }, 0);

      if (positionValue <= 0) return;

      const categories = {
        industry: metadata.industry || 'Unknown',
        sector: metadata.sector || 'Unknown',
        marketCap: getMarketCapCategory(metadata.marketCap),
      };

      Object.entries(categories).forEach(([key, category]) => {
        allocations[key][category] = (allocations[key][category] || 0) + positionValue;
      });
    });

    const buildGroup = (key, title, palette) => {
      const sorted = Object.entries(allocations[key]).sort((a, b) => b[1] - a[1]);
      const total = sorted.reduce((sum, [, value]) => sum + value, 0);
      const visible = sorted.length > 4
        ? [...sorted.slice(0, 3), ['Other', sorted.slice(3).reduce((sum, [, value]) => sum + value, 0)]]
        : sorted;

      let cursor = 0;
      const items = visible.map(([label, value], index) => {
        const percentage = total > 0 ? (value / total) * 100 : 0;
        const start = cursor;
        cursor += percentage;
        return {
          label,
          value: `${percentage.toFixed(percentage >= 10 ? 0 : 1)}%`,
          color: palette[index % palette.length],
          start,
          end: cursor,
        };
      });

      const gradient = items.length
        ? `conic-gradient(${items.map((item) => `${item.color} ${item.start}% ${item.end}%`).join(', ')})`
        : 'conic-gradient(#ebe8f4 0 100%)';

      return { title, items, gradient, groupCount: sorted.length };
    };

    return [
      buildGroup('industry', 'By industry', diversificationPalettes[0]),
      buildGroup('sector', 'By sector', diversificationPalettes[1]),
      buildGroup('marketCap', 'By market cap', diversificationPalettes[2]),
    ];
  }, [portfolio, portfolioStockMetadata, stockData]);
  












  
  useEffect(() => {
  let sum = 0;
  Object.values(portfolio).forEach(purchases => {
    purchases.forEach(purchase => {
      //console.log(purchase.shares, purchase.purchasePrice);
      if (purchase.shares != 0){
      sum += purchase.shares * purchase.purchasePrice;}
    });
  });
  console.log(sum);
  setTotalPurchaseValue(sum);
}, [portfolio]);
  const [lineChartData, setLineChartData] = useState({
  options: {
    xaxis: {
      categories: [],
  
    },
    yaxis: [
      {
        seriesName: 'Portfolio Value',
        
      },
    ],
    
  },
  series: [
    {
      name: 'Portfolio Value',
      data: [],
    },
  ],
});
  const [isLineChart, setIsLineChart] = useState(false);
  const [range, setRange] = useState('1y');
  const [interval, setInterval] = useState('1wk');
  
  
  
  
  
  
const fetchHistoricalStockData = async (ticker) => {
  try {
    const response = await axios.get('/auth/price-chart', {
      params: { symbol: ticker, range },
    });

    // Return empty object if chart/result missing
    const chart = response.data.chart?.result?.[0];
    if (!chart) {
      console.warn(`No chart data for ${ticker}:`, response.data.chart?.error?.description || 'Unknown error');
      return { timestamps: [], close: [] };
    }

    return {
      timestamps: chart.timestamp || [],
      close: chart.indicators?.quote?.[0]?.close || [],
    };
  } catch (err) {
    console.warn(`Failed to fetch ${ticker}:`, err.message);
    return { timestamps: [], close: [] };
  }
};

  
  const handleRangeButtonClick = (selectedRange) => {
  let selectedInterval;

  switch (selectedRange) {
    case '1d':
      selectedInterval = '1m';
      break;
    case '5d':
      selectedInterval = '5m';
      break;
    case '1mo':
      selectedInterval = '1h';
      break;
    case '3mo':
    case '6mo':
      selectedInterval = '1d';
      break;
    case '1y':
      selectedInterval = '1d';
      break;
    case '2y':
    case '5y':
      selectedInterval = '1wk';
      break;
    case 'max':
      selectedInterval = '1mo';
      break;
    case 'ytd':
      selectedInterval = '1d';
      break;
    default:
      selectedInterval = '1d';
  }
  console.log('Timestamps:', selectedRange);
console.log('interval', selectedInterval);
  setRange(selectedRange);
  setInterval(selectedInterval);
  console.log("RUUUUN");
  fetchDataAndUpdateChart();
  
};
  
  
  
  
  
  
  
  
  const fetchDataAndUpdateChart = async () => {
  try {
    // Fetch stock data for each stock in the portfolio
    const stockTickers = Object.keys(portfolio);

  // Fetch historical data for all stocks
  const allStockData = await Promise.all(
    stockTickers.map(ticker => fetchHistoricalStockData(ticker))
  );

    // Calculate line chart data
    const timestamps = allStockData.find(d => d.timestamps.length)?.timestamps || [];
  const lineChartDataValues = timestamps.map((timestamp, i) => {
    return stockTickers.reduce((total, ticker, idx) => {
      const stock = allStockData[idx];
      const price = stock.close[i] || 0; // fallback to 0 if missing
      const shares = portfolio[ticker].reduce((sum, p) => sum + p.shares, 0);
      return total + price * shares;
    }, 0);
  });

    // Set line chart data
    setLineChartData({
      options: {
            stroke: {
              width: [2], // Adjust the width as needed
              colors: ['#808EF6'], // Specify your desired colors
            },
            legend: {
              show: false,
            },
            tooltip: {
              enabled: false,
              marker: {
                show: false,
              },
              onDatasetHover: {
                highlightDataSeries: false,
              },
              followCursor: false,
              intersect: false,
              
            },
            chart: {
              type: 'line',
              
              toolbar: {
                autoSelected: 'none',
                show: false,
              },
            },
            states: {
              normal: {
                filter: {
                  type: 'none',
                  value: 0,
                },
              },
              hover: {
                filter: {
                  type: 'none',
                  value: 0,
                },
              },
            },
            grid: {
              position: 'back',
              borderColor: '#FDFBFF',
            },
            xaxis: {
              type: 'category',
              tickAmount: 5,
        axisTicks: {
          show: false,
          
        },
              categories: timestamps.map((timestamp) => new Date(timestamp * 1000).toLocaleDateString()),
        labels: {
          show: false,
                formatter: function (val) {
                  // Check if lineChartData and its options are available
                  if (lineChartData && lineChartData.options && lineChartData.options.chart) {
                    const range = lineChartData.options.chart.range;

                    // Customize date-time formats based on the selected range
                    if (range === '1d') {
                      // Format for 1 day
                      return dayjs(val).format('HH:mm');
                    } else if (['5d', '1mo', '3mo', '6mo'].includes(range)) {
                      // Format for 5 days, 1 month, 3 months, 6 months
                      return dayjs(val).format('DD HH');
                    } else if (['1y', '2y', '5y', 'ytd', 'max'].includes(range)) {
                      // Format for 1 year, 2 years, 5 years, year-to-date, max
                      return dayjs(val).format('MMM YYYY');
                    }
                  }

                  // Default format for other cases
                  return dayjs(val).format('MMM');
                },
        rotate: 0,
              },
              crosshairs: {
                show: false,
              },
              tooltip: {
                enabled: false,
              },
            },
      zoom: {
        enabled: false
        },
            yaxis: {
              opposite: true,
        labels: {
          formatter: function (val) {
      // Format numbers nicely with commas and 2 decimals
      if (val === null || val === undefined) return '0';
      return formatPortfolioChartValue(val);
    },
        style: {
            colors: [],
            fontSize: '10px',
            fontFamily: 'Lexend',
            fontWeight: 400,
            cssClass: 'apexcharts-yaxis-label',
        },},
              //tickAmount: 6,
              /*labels: {
                formatter: function (val, index) {
                  return val !== null ? val.toFixed(2) : val;
                },
              },*/
              forceNiceScale: true,
              tooltip: {
                enabled: false,
              },
              crosshairs: {
                show: false,
              },
            },
            markers: {
              size: 0,
            },
          },
      series: [
        {
          
          data: lineChartDataValues,
        },
      ],
    });
  } catch (error) {
    console.error('Failed to fetch and update chart data', error);
  }
};
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  useEffect(() => {
     
    const fetchData = async () => {
      console.log("AAAABBBBCCCC");



      const now = Date.now();
        
        if (!isLoggedIn || !user || now - lastFetchTime < cooldownTime) {
            console.log("Skipping fetch due to cooldown.");
            return; // Skip request if cooldown hasn't passed
        }
        
        setLastFetchTime(now);
      try {
        if (isLoggedIn && user) {
          // Fetch portfolio data
          const portfolioResponse = await getPortfolio();
          const portfolioData = portfolioResponse.data.portfolio;
          const endpointStockData = Array.isArray(portfolioResponse.data.stockData)
            ? portfolioResponse.data.stockData
            : [];
          setPortfolioStockMetadata(endpointStockData);
      
          setRawPortfolio(portfolioData);
          // Process portfolio data to combine multiple purchases of the same stock
          const processedPortfolio = processPortfolioData(portfolioData);

          // Set the processed portfolio data
          setPortfolio(processedPortfolio || {});

          const stockTickers = Object.keys(processedPortfolio);
          const endpointDataBySymbol = new Map(endpointStockData.map((item) => [item.symbol, item]));
          const combinedData = Object.fromEntries(stockTickers.map((ticker) => {
            const item = endpointDataBySymbol.get(ticker) || {};
            const price = Number(item.regularMarketPrice ?? item.price);
            return [ticker, [{ currentPrice: Number.isFinite(price) ? price : 'N/A' }]];
          }));
          setStockData(combinedData);
      
      const calculatedTotalBalance = Object.entries(processedPortfolio).reduce((total, [stock, purchases]) => {
            return total + purchases.reduce((subTotal, purchase) => {
              const currentPrice = Number(combinedData[stock]?.[0]?.currentPrice) || 0;
              return subTotal + (currentPrice * purchase.shares);
            }, 0);
          }, 0);
          setTotalBalance(calculatedTotalBalance);
          if (!firstRun) {
          // Fetch historical sock data for each symbol/ticker
          const stockDataPromises2 = stockTickers.map((ticker) => fetchHistoricalStockData(ticker));
          console.log("fetching historical data 491");
          const stockDataResults2 = await Promise.all(stockDataPromises2);

          // Combine stock data with portfolio data
          const combinedData2 = Object.fromEntries(stockTickers.map((ticker, index) => [ticker, stockDataResults2[index]]));
          setStockData2(combinedData2);
          
          
          // Calculate line chart data
          const timestamps = stockDataResults2.find((item) => item.timestamps.length)?.timestamps || [];
          const lineChartDataValues = timestamps.map((timestamp) => {
            const totalValue = Object.entries(rawPortfolio).reduce((total, [stock, purchases]) => {
              
              const currentPrice = combinedData2[stock]?.close || [];
              const priceAtTimestamp = currentPrice[timestamps.indexOf(timestamp)] || 0;
          
              
              const currentTimestampEpoch = new Date(timestamp * 1000).getTime();
              console.log("currentTimestampEpoch", currentTimestampEpoch);
              
              const validPurchases = purchases.filter(purchase => {
                const purchaseTimestampEpoch = new Date(purchase.datetime).getTime();
                console.log("purchaseTimestampEpoch", purchaseTimestampEpoch);
                return purchaseTimestampEpoch <= currentTimestampEpoch;
              });
          
              
              const shares = validPurchases.reduce((subTotal, purchase) => {
                return subTotal + parseFloat(purchase.shares);
              }, 0);
          
              
              return total + (priceAtTimestamp * shares);
            }, 0);
          
            return Number(totalValue.toFixed(2));
          });
          
// Set line chart data
setLineChartData({
  options: {
            stroke: {
              width: [2], // Adjust the width as needed
              colors: ['#808EF6'], // Specify your desired colors
            },
            legend: {
              show: false,
            },
            tooltip: {
              enabled: false,
              marker: {
                show: false,
              },
              onDatasetHover: {
                highlightDataSeries: false,
              },
              followCursor: false,
              intersect: false,
              
            },
            chart: {
              type: 'line',
              
              toolbar: {
                autoSelected: 'none',
                show: false,
              },
            },
            states: {
              normal: {
                filter: {
                  type: 'none',
                  value: 0,
                },
              },
              hover: {
                filter: {
                  type: 'none',
                  value: 0,
                },
              },
            },
            grid: {
              position: 'back',
              borderColor: '#FDFBFF',
            },
      zoom: {
        enabled: false
        },
            xaxis: {
              type: 'category',
              tickAmount: 4,
        tickPlacement: 'between',
        
        axisTicks: {
          show: false,
          
        },
              categories: timestamps.map((timestamp) => new Date(timestamp * 1000).toLocaleDateString()),
        labels: {
          hideOverlappingLabels: true,
          show: false,
          
                formatter: function (val) {
          
                  // Check if lineChartData and its options are available
                  if (lineChartData && lineChartData.options && lineChartData.options.chart) {
                    

                    // Customize date-time formats based on the selected range
                    if (range === '1d') {
                      // Format for 1 day
                      return dayjs(val).format('HH:mm');
                    } else if (['5d', '1mo', '3mo', '6mo'].includes(range)) {
                      // Format for 5 days, 1 month, 3 months, 6 months
                      return dayjs(val).format('DD.MM');
                    } else if (['1y', '2y', '5y', 'ytd', 'max'].includes(range)) {
                      // Format for 1 year, 2 years, 5 years, year-to-date, max
                      return dayjs(val).format('MMM YYYY');
                    }
                  }

                  // Default format for other cases
                  return dayjs(val).format('MMM');
                },
        rotate: 0,
              },
              crosshairs: {
                show: false,
              },
              tooltip: {
                enabled: false,
              },
            },
            yaxis: {
              opposite: true,
        labels: {
          formatter: formatPortfolioChartValue,
        style: {
            colors: [],
            fontSize: '10px',
            fontFamily: 'Lexend',
            fontWeight: 400,
            cssClass: 'apexcharts-yaxis-label',
        },},
              //tickAmount: 6,
              /*labels: {
                formatter: function (val, index) {
                  return val !== null ? val.toFixed(2) : val;
                },
              },*/
              forceNiceScale: true,
              tooltip: {
                enabled: false,
              },
              crosshairs: {
                show: false,
              },
            },
            markers: {
              size: 0,
            },
          },
  
  
  
  
  
  
  
  
  
  
  
  
  
  series: [
    {
      
      data: lineChartDataValues,
    },
  ],
});
      
      
      
      
      
      
      
      
      
        }}
        setFirstRun(false);
    
      } catch (error) {
        console.error('Failed to fetch data', error);
      }
    };

    fetchData();
  }, [user, isLoggedIn, range, interval]);
    const [activeStatement, setActiveStatement] = useState('basics');
  
  const handleButtonClick = (statementType) => {
    setActiveStatement(statementType);
    
  };
  const processPortfolioData = (portfolioData) => {
  const processedPortfolio = {};

  Object.keys(portfolioData).forEach((stock) => {
    // Combine multiple purchases for the same stock
    const combinedPurchases = combinePurchases(portfolioData[stock]);

    processedPortfolio[stock] = combinedPurchases;
  });

  return processedPortfolio;
};
useEffect(() => {
  const fetchSum = async () => {
    try {
      const calculatedTotalBalance = pieChartData.reduce((total, data) => total + data.totalHolding, 0);
      setTotalBalance(calculatedTotalBalance);

    } catch (error) {
      console.error('Failed to fetch total', error);
    }
  };

  fetchSum();
}, [user, isLoggedIn, Date.now()]);


const combinePurchases = (purchases) => {
  const combinedPurchases = purchases.reduce((result, purchase) => {
    const existingPurchase = result.find((p) => p.stock === purchase.stock);

    if (existingPurchase) {
      // Convert shares and purchase price to numbers before performing calculations
      existingPurchase.shares += Number(purchase.shares);
      existingPurchase.weightedPurchasePrice += Number(purchase.shares) * Number(purchase.purchasePrice);
    } else {
      // Convert shares and purchase price to numbers before adding to the result array
      result.push({
        stock: purchase.stock,
        shares: Number(purchase.shares),
        purchasePrice: Number(purchase.purchasePrice),
        weightedPurchasePrice: Number(purchase.shares) * Number(purchase.purchasePrice),
      });
    }

    return result;
  }, []);

  // Calculate the weighted average purchase price for each combined purchase
  combinedPurchases.forEach((purchase) => {
    purchase.purchasePrice = (purchase.weightedPurchasePrice / purchase.shares).toFixed(2);
    delete purchase.weightedPurchasePrice; // Remove the weightedPurchasePrice property
  });

  return combinedPurchases;
};
///
const generateRandomColors = (count) => {
  const palette = [
    '#5932EA',
    '#2F80ED',
    '#18B892',
    '#FFB020',
    '#F0648B',
    '#7C5CE7',
    '#22A6C7',
    '#FF7A45',
    '#75C85A',
    '#D95FC1',
  ];
  return Array.from({ length: count }, (_, index) => palette[index % palette.length]);
  };
const pieChartData = Object.entries(portfolio)
  .map(([stock, purchases]) => {
    const totalHolding = purchases.reduce((total, purchase) => {
      const currentPrice = stockData[stock]?.[0]?.currentPrice || 0;
      return total + (currentPrice === 'N/A' ? 0 : currentPrice * purchase.shares);
    }, 0);

    if (totalHolding > 0) return { stock, totalHolding };
    return null;
  })
  .filter(Boolean);


  // Extract labels and data for the pie chart
  const pieChartLabels = pieChartData.map((data) => data.stock);
  const pieChartDataValues = pieChartData.map((data) => data.totalHolding);

  // Define colors for the chart
  const pieChartColors = generateRandomColors(pieChartData.length);

  // Configure the pie chart data
  const pieChartOptions = {
  
  plugins: {
    legend: {
      display: false, // 🚀 Hides the legend
    },
    datalabels: {
    font: {
        family: 'Poppins',
        size: 11,
        weight: 500,
      },
      color: (context) => {
        // Get the background color of the chart
        const backgroundColor = context.dataset.backgroundColor[context.dataIndex];

        // Determine a contrasting text color based on the background color
        const textColor = getContrastColor(backgroundColor);

        return textColor;
      },
      formatter: (value, context) => {
        const label = context.chart.data.labels[context.dataIndex];
        return label;
      },
      anchor: 'end', // Anchor label to the outer edge
      align: 'start', // Align the label to the start of the anchor
      offset: 30,
    },
  },
  tooltips: {
    enabled: false,
    
    callbacks: {
      label: (tooltipItem, data) => {
        const dataIndex = tooltipItem.index;
        const label = data.labels[dataIndex];
        const value = data.datasets[0].data[dataIndex];
        return `${label}: $${value.toFixed(2)}`;
      },
    },
  },
  hover: {
    //mode: null, // ❌ Disable hover effects
  },
  interaction: {
    mode: 'none', // ❌ Disable all interactions
  },
};
function getContrastColor(backgroundColor) {
  // Calculate the relative luminance of the background color
  const luminance = 0.2126 * backgroundColor[0] + 0.7152 * backgroundColor[1] + 0.0722 * backgroundColor[2];

  // Use white text for dark backgrounds and black text for light backgrounds
  return luminance > 0.5 ? '#000' : '#fff';
}
  
const handleButtonP = () => {
    setIsLineChart(false);
    // Additional logic or actions you want to perform on button click
  };
const handleButtonL = () => {
    setIsLineChart(true);
    setRange('1y');
    // Additional logic or actions you want to perform on button click
  };
  
  
  const totalProfit = Object.entries(portfolio).reduce((total, [stock, purchases]) => {
  return total + purchases.reduce((subTotal, purchase) => {
    const currentPrice = stockData[stock]?.[0]?.currentPrice || 0; // Current price of the stock
    const purchasePrice = purchase.purchasePrice; // Purchase price of the stock
    const shares = purchase.shares; // Number of shares

    // Calculate profit for this purchase only if shares are positive
    if (shares > 0) {
      const profit = (currentPrice - purchasePrice) * shares;
      return subTotal + profit;
    } else {
      return subTotal;
    }
  }, 0);
}, 0);
  
let profitColorClass = '';
if (totalProfit < 0) {
  profitColorClass = 'negative';
} else if (totalProfit > 0) {
  profitColorClass = 'positive';
} else {
  profitColorClass = 'neutral';
}
useEffect(() => {
  if (Object.keys(portfolio).length > 0) {
    fetchDataAndUpdateChart(); // ensures chart shows on first load
  }
}, [portfolio]);
///
  return (
  <div className="portfolioPageRoot" style={{ height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingRight: "var(--sidebar-width, 306px)" }}>
    {purchasePopUpVisible && (
  <div 
    className="backgroundShade" 
    style={{
      position: 'fixed',
      top: 0,
      left: 1,
      
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999999,
    }}
  >
    <div 
      className="popupContainer portfolioOrderModal" 
      style={{
        position: 'relative',
        backgroundColor: '#fff',
        borderRadius: 16,
        padding: 24,
        width: '90%',
        maxWidth: 400,
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
      }}
    >
      <button
        className="closeButton portfolioOrderClose"
        onClick={() => setPurchasePopUpVisible(false)}
        style={{
          position: 'absolute',
          top: 12,
          right: 12,
          background: 'transparent',
          border: 'none',
          fontSize: 20,
          fontWeight: 600,
          cursor: 'pointer',
          color: '#555',
        }}
      >
        ×
      </button>

      <StockPurchase />
    </div>
  </div>
)}

    {!authReady ? (
      <div className="portfolioAuthLoader" role="status" aria-live="polite">
        <span className="portfolioAuthSpinner" aria-hidden="true" />
        <span>Loading your portfolio…</span>
      </div>
    ) : isLoggedIn ? (
      <div>
        {user && user.username ? (
          <div >
            
            {Object.keys(portfolio).length === 0 ? (
              <div className="portfolioEmptyState">
                <section className="portfolioEmptyHero">
                  <div className="portfolioEmptyCopy">
                    <span className="portfolioEmptyEyebrow">Your investing workspace</span>
                    <h1>Build a clearer picture of your portfolio.</h1>
                    <p>
                      Record your first transaction and StockSleuth will turn your
                      holdings into performance, allocation, and risk insights.
                    </p>
                    <div className="portfolioEmptyActions">
                      <button
                        type="button"
                        className="portfolioEmptyPrimary"
                        onClick={() => setPurchasePopUpVisible(true)}
                      >
                        <span className="portfolioEmptyPlus">+</span>
                        Record first transaction
                      </button>
                      <Link className="portfolioEmptySecondary" to="/scanner">
                        Find a stock
                        <span aria-hidden="true">→</span>
                      </Link>
                    </div>
                    <div className="portfolioEmptyNote">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 22s8-3.6 8-10V5l-8-3-8 3v7c0 6.4 8 10 8 10Z" />
                        <path d="m9 12 2 2 4-4" />
                      </svg>
                      Add past transactions too—this does not place a real order.
                    </div>
                  </div>

                  <div className="portfolioEmptyPreview" aria-label="Preview of portfolio analytics">
                    <div className="portfolioPreviewTop">
                      <div>
                        <span>Portfolio value</span>
                        <strong>$24,860.40</strong>
                      </div>
                      <span className="portfolioPreviewGain">+8.42%</span>
                    </div>
                    <div className="portfolioPreviewChart">
                      <svg viewBox="0 0 520 190" preserveAspectRatio="none" aria-hidden="true">
                        <defs>
                          <linearGradient id="emptyPortfolioGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#7658ef" stopOpacity=".34" />
                            <stop offset="100%" stopColor="#7658ef" stopOpacity="0" />
                          </linearGradient>
                        </defs>
                        <path className="portfolioPreviewArea" d="M0 165 C35 154 55 161 82 142 S133 149 158 120 S203 132 232 96 S280 110 309 76 S357 91 389 54 S445 73 520 18 L520 190 L0 190 Z" />
                        <path className="portfolioPreviewLine" d="M0 165 C35 154 55 161 82 142 S133 149 158 120 S203 132 232 96 S280 110 309 76 S357 91 389 54 S445 73 520 18" />
                      </svg>
                      <span>Preview</span>
                    </div>
                    <div className="portfolioPreviewHoldings">
                      <div><i className="portfolioDot portfolioDotPurple" /><span>Technology</span><strong>52%</strong></div>
                      <div><i className="portfolioDot portfolioDotBlue" /><span>Financials</span><strong>28%</strong></div>
                      <div><i className="portfolioDot portfolioDotGold" /><span>Other</span><strong>20%</strong></div>
                    </div>
                  </div>
                </section>

                <section className="portfolioEmptyBenefits">
                  <div className="portfolioEmptyBenefit">
                    <span className="portfolioBenefitIcon portfolioBenefitPurple">
                      <svg viewBox="0 0 24 24"><path d="M4 19V9m6 10V5m6 14v-7m4 7H2" /></svg>
                    </span>
                    <div><strong>Track performance</strong><p>See your return, profit, and portfolio value over time.</p></div>
                  </div>
                  <div className="portfolioEmptyBenefit">
                    <span className="portfolioBenefitIcon portfolioBenefitBlue">
                      <svg viewBox="0 0 24 24"><path d="M12 3v9h9A9 9 0 1 1 12 3Z" /><path d="M15 3.5A7.5 7.5 0 0 1 20.5 9H15Z" /></svg>
                    </span>
                    <div><strong>Understand allocation</strong><p>Explore exposure by holding, sector, market cap, and industry.</p></div>
                  </div>
                  <div className="portfolioEmptyBenefit">
                    <span className="portfolioBenefitIcon portfolioBenefitGold">
                      <svg viewBox="0 0 24 24"><path d="M12 2 4 6v6c0 5 3.4 8.8 8 10 4.6-1.2 8-5 8-10V6Z" /><path d="m8.5 12 2.2 2.2 4.8-5" /></svg>
                    </span>
                    <div><strong>Spot concentration risk</strong><p>Catch imbalances before a single position dominates your portfolio.</p></div>
                  </div>
                </section>

                <div className="portfolioEmptyExplore">
                  Not ready to add a transaction?
                  <Link to="/swipe">Discover companies in Swiping <span>→</span></Link>
                </div>
              </div>
            ) : (<>
      
              <div className="portfolioMainLayout" style={{ display: 'flex' }}>
                

                
                
        <div className="portfolioCanvas">
          
          <div className="holdings">
          <div className='Statements portfolioTabs' style={{position: "absolute", top: 16, marginLeft: 0, padding: "0 20% 0 3%", width: "calc(100% - 23%)"}}>
      <button
  className={activeStatement === "basics" ? "SelectorActive" : "Selector"}
  onClick={() => handleButtonClick("basics")}
>
  Basics
</button>
<button
  className={activeStatement === "hist" ? "SelectorActive" : "Selector"}
  onClick={() => handleButtonClick("hist")}
>
Operations History
</button>
<button
  className={activeStatement === "score" ? "SelectorActive" : "Selector"}
  onClick={() => handleButtonClick("score")}
>
Portfolio AI
</button>
</div>
{activeStatement === "basics" || activeStatement === "hist" ? (
            <div className="portfolioPanelBody" style={{ marginTop: '70px', flex: '1', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            { activeStatement === "basics" ? (<div className="portfolioHoldingsContent">
              <div className="portfolioHoldingsIntro">
                <div>
                  <h2 style={{textAlign: 'left'}}>Your holdings</h2>
                  <p>Monitor positions and spot what is driving your return.</p>
                </div>
                <button className="portfolioAddPosition" onClick={() => setPurchasePopUpVisible(true)}>
                  <span aria-hidden="true">+</span> Add position
                </button>
              </div>
              <div className="portfolioMiniStats">
                <div><span>Positions</span><strong>{sortedData.length}</strong></div>
                <div><span>Cost basis</span><strong>${totalPurchaseValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
                <div><span>Total return</span><strong className={profitColorClass}>{totalPurchaseValue ? `${totalProfit >= 0 ? '+' : ''}${((totalProfit / totalPurchaseValue) * 100).toFixed(2)}%` : '—'}</strong></div>
              </div>
              <div className="portfolioTableShell">
                <table className="portfolioHoldingsTable">
  <thead>
    <tr style={{ fontSize: 12, fontWeight: 'normal' }}>
      {['stock', 'shares', 'purchasePrice', 'currentPrice', 'totalHolding', 'totalProfit', 'pl'].map((header, idx) => {
        // Map header variables to custom display names
        const headerNames = {
          stock: 'Ticker',
          shares: 'Shares',
          purchasePrice: 'Open Price',
          currentPrice: 'Market Price',
          totalHolding: 'Value',
          totalProfit: 'Profit',
          pl: 'P/L %',
        };

        return (
          <th
            key={idx}
            style={{ paddingBottom: 6, fontWeight: 'normal', cursor: ['purchasePrice', 'currentPrice'].includes(header) ? 'default' : 'pointer' }}
            onClick={['purchasePrice', 'currentPrice'].includes(header) ? null : () => sortTable(header)} // Skip sorting on specific columns
          >
            {headerNames[header]} {/* Display custom header name */}
            {sortConfig.key === header ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓') : null}
          </th>
        );
      })}
    </tr>
  </thead>
  <tbody>
    {sortedData.map((row, index) => (
      <tr key={`${row.stock}-${index}`} style={{ fontSize: 12, marginTop: 10 }}>
        <td>
          <Link to={`/stock/${row.stock}`} style={{ textDecoration: 'none', color: 'black' }}>
            {row.stock}
          </Link>
        </td>
        <td style={{ paddingTop: 6, paddingBottom: 6 }}>{row.shares}</td>
        <td>{row.purchasePrice}</td>
        <td>{row.currentPrice}</td>
        <td>{row.totalHolding}</td>
        <td>{row.totalProfit}</td>
        <td
          style={{
            color: row.pl === 'N/A'
              ? 'black'
              : parseFloat(row.pl) > 0
              ? '#4f9c4e'
              : parseFloat(row.pl) < 0
              ? '#f06e6e'
              : 'grey',
          }}
        >
          {row.pl}
        </td>
      </tr>
    ))}
  </tbody>
</table>
              </div>
              <p className="portfolioTableHint">Select a ticker to open its full analysis. Click a column heading to sort.</p>
            </div>) : (<div className="portfolioOrderHistoryWrap" style={{width: "100%"}}><OrderHistory /></div>)}


            </div>) : (<div className="portfolioAiPanel" style={{ position: "absolute", top: 30, bottom: -10, width: "100%" }}>
            <div
                              
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                
                                justifyContent: "center",
                                width: "calc(100% - 60px)",
                                height: "calc(100% - 60px)",
                                padding: 30,
                                minHeight: 0,
                              }}
                            >
                      <div className="portfolioAiHeader">
                        <div className="portfolioAiIdentity">
                          <PortfolioAiMark />
                          <div><strong>Portfolio AI</strong><span><i /> Ready to analyze your holdings</span></div>
                        </div>
                        <span className="portfolioAiNotice">AI can make mistakes</span>
                      </div>
                      {/* Chat messages */}
                      <div
              className="chat-box2 portfolioChatMessages"
              style={{
                flex: 1,
                overflowY: "auto",
                marginBottom: "1rem",
                fontSize: 12,
              }}
            >
              {messagesAI.map((m, i) => {
                const isAI = m.sender === "sleuthAI";
              const isLast  = i === messagesAI.length - 1;
                return (
                  <div
                    key={i}
                    className={`portfolioMessageRow ${isAI ? "portfolioMessageRowAi" : "portfolioMessageRowUser"}`}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: isAI ? "flex-start" : "flex-end",
                      marginBottom: "0.75rem",
                    }}
                  >
                    {isAI ? (
                      <>
                        {/* AI avatar on left */}
                        <PortfolioAiMark compact />
                        <div className="portfolioMessageBubble portfolioMessageBubbleAi"
                        
                          style={{
                            background: "rgb(255 180 0 / 26%)",
                            padding: "0.5rem 0.75rem",
                            borderRadius: 8,
                            maxWidth: "80%",
                            textAlign: "justify",
                          }}
                        ><div className={ showTypewriter && isLast ? 'typewriter' : '' }>
                          <ReactMarkdown remarkPlugins={[remarkGfm]} style={{ margin: 0 }} >
                            {m.text}
                          </ReactMarkdown></div>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* User bubble first, then avatar on right */}
                        <div className="portfolioMessageBubble portfolioMessageBubbleUser"
                          style={{
                            background: "rgb(89 50 234 / 14%)",
                            padding: "0.5rem 0.75rem",
                            borderRadius: 8,
                            maxWidth: "80%",
                            textAlign: "justify",
                          }}
                        >
                          <ReactMarkdown remarkPlugins={[remarkGfm]} style={{ margin: 0 }}>
                            {m.text}
                          </ReactMarkdown>
                        </div>
                        {user?.profile_image && (
                          <img
                            src={`data:image/jpeg;base64,${user.profile_image}`}
                            alt="pfp"
                            className="portfolioMessageAvatar"
                            style={{
                              marginLeft: 8,
                              width: 26,
                              height: 26,
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                );
              })}
              {isThinking && (
                
                <div
                    className="portfolioMessageRow portfolioMessageRowAi"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "flex-start",
                      marginBottom: "0.75rem",
                    }}
                  >
                      <>
                        {/* AI avatar on left */}
                        <PortfolioAiMark compact />
                        <div className="portfolioMessageBubble portfolioMessageBubbleAi portfolioThinkingBubble"
                          style={{
                            background: "rgb(255 180 0 / 26%)",
                            padding: "0.5rem 0.75rem",
                            borderRadius: 8,
                            maxWidth: "80%",
                            textAlign: "justify",
                          }}
                        >
                          
                  <ThinkingIndicator />
                
                        </div>
                      </>
                    
                  </div>
              )}
              <div ref={chatEndRef} />
            </div>
            
            
                      {/* Input + Send */}
                      {messagesAI.length < 2 ? (
                      <div
                      className="chat-box2 portfolioPromptChips"
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      flexWrap: "wrap",
                      marginBottom: "0.5rem",
                      overflowX: "auto",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {shownExamples.map((q, i) => (
                     <button
                key={i}
                className="gradientOutlineText portfolioPromptChip"
                onClick={() => { setInputText(q); handleSend(q); }}
              >
                {q}
              </button>
                    ))}
                  </div>) : (<></>)}
                      <div
                      className="chat-box2 portfolioChatComposer"
                        style={{
                          display: "flex",
                          gap: "0.3rem",
                          
                        }}
                      >
                        <input
                          type="text"
                          spellCheck="false"
                          className="chat-box2 portfolioChatInput"
                          value={inputText}
                          onChange={(e) => setInputText(e.target.value)}
                          onKeyDown={(e) => e.key === "Enter" && handleSend()}
                          placeholder="Type your question…"
                          style={{
                            flex: 1,
                            padding: "0.5rem",
                            borderRadius: 12,
                            border: "1px solid #aaa",
                          }}
                        />
                        <button
                        className="chat-box2 portfolioSendButton"
                          onClick={handleSend}
                          disabled={isThinking || !inputText.trim()}
                          aria-label="Send message"
                          style={{
                            padding: "0.5rem 1rem",
                            borderRadius: 12,
                            background: "#5932ea",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          <span>Send</span><span aria-hidden="true">&uarr;</span>
                        </button>
                      </div>
                    </div>
            </div>)}
            

          </div>
          
          
          <div className="piechart" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', right: 'calc(var(--page-gutter, 3.5%) + var(--sidebar-width, 306px))'}}>
            {isLineChart ? (<>
            <button onClick={handleButtonP}  className = "chartsButton" style= {{position: 'absolute', padding: 0, margin: 0, right: 20, top: 14, width: 25, height: 25}}><img src={PieChart} style= {{width: '100%', height: '100%'}}/></button>
            <button onClick={handleButtonL} className = "chartsButtonActive" style= {{position: 'absolute', padding: 0, margin: 0, right: 47, top: 14, width: 25, height: 25}}><img src={WhiteLine}  style= {{width: '100%', height: '100%'}}/></button>
            </>) : (<>
            <button onClick={handleButtonP}  className = "chartsButtonActive" style= {{position: 'absolute', padding: 0, margin: 0, right: 20, top: 14, width: 25, height: 25}}><img src={WhitePie} style= {{width: '100%', height: '100%'}}/></button>
            <button onClick={handleButtonL} className = "chartsButton" style= {{position: 'absolute', padding: 0, margin: 0, right: 47, top: 14, width: 25, height: 25}}><img src={LineChart}  style= {{width: '100%', height: '100%'}}/></button>
            </>)}
            { !isLineChart ? (<>
              <div style={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '80%', height: '80%'}}>
                <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                  <Pie data={{ labels: pieChartLabels, datasets: [{data: pieChartDataValues, backgroundColor: pieChartColors, borderColor: '#ffffff', borderWidth: 2, },],}} options={pieChartOptions} plugins={[ChartDataLabels]}/>
                </div>
              </div>
              
            </>) : (<>
              <div style={{ flex: '1', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '80%', height: '80%' }}>
                <div style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                  <Chart
                    options={lineChartData.options}
                    series={lineChartData.series}
                    type={'line'}
                    height={'100%'}
                    width={'100%'}
                  />
                </div>
              </div>
              
              <div className="RangeSelector" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 30px', position: 'absolute', bottom: 6 }}>
                <button className={`range-button ${range === '1d' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('1d')}>1d</button>
                <button className={`range-button ${range === '5d' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('5d')}>5d</button>
                <button className={`range-button ${range === '1mo' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('1mo')}>1mo</button>
                <button className={`range-button ${range === '3mo' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('3mo')}>3mo</button>
                <button className={`range-button ${range === '6mo' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('6mo')}>6mo</button>
                <button className={`range-button ${range === '1y' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('1y')}>1y</button>
                <button className={`range-button ${range === '2y' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('2y')}>2y</button>
                <button className={`range-button ${range === '5y' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('5y')}>5y</button>
                
                <button className={`range-button ${range === 'ytd' ? 'active' : ''}`} onClick={() => handleRangeButtonClick('ytd')}>ytd</button>
              </div>
            </>)}
          </div>
          
          
          
          
        
        <div className="balance" style={{right: 'calc(var(--page-gutter, 3.5%) + var(--sidebar-width, 306px))'}}>${totalBalance.toFixed(2)} 
        <span style={{display: 'flex'}} className={`profit ${profitColorClass}`}>{totalProfit < 0 ? <img src={Down} style={{width: 20, paddingRight: 5}} alt="Down" /> : totalProfit > 0 ? <img src={Up} style={{width: 20,paddingRight: 5}} alt="Up" /> : <img src={Flat} style={{width: 20, paddingRight: 5}} alt="Flat" />}${totalProfit.toFixed(2)} ({((totalProfit / totalPurchaseValue) * 100).toFixed(2)}%)  All time</span></div>
        <section className="history diversificationPanel" style={{right: 'calc(var(--page-gutter, 3.5%) + var(--sidebar-width, 306px))'}}>
          <div className="diversificationHeader">
            <h2>Diversification</h2>
          </div>
          <div className="diversificationGrid">
            {diversificationData.map((group) => (
              <article className="diversificationCard" key={group.title}>
                <div className="diversificationDonut" style={{ background: group.gradient }}>
                  <div><strong>{group.groupCount}</strong><span>groups</span></div>
                </div>
                <div className="diversificationDetails">
                  <h3>{group.title}</h3>
                  {group.items.map((item) => (
                    <div className="diversificationLegendRow" key={item.label}>
                      <span><i style={{ backgroundColor: item.color }} />{item.label}</span><strong>{item.value}</strong>
                    </div>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
          </div>
        </div>
            </>)}
          </div>
        ) : (
          <p>No username found. Please sign in.</p>
        )}
      </div>
    ) : (
      <div>
        
      </div>
    )}
  
  
  
  
  
  
  {/*
  <div style={{width: "100%", height: "100vh",}}>
  
  {isLoggedIn ? (
  <div>
    <div className="text-wrapper-39">Your Potfolio</div>
        <div className="overview">
          
        </div>

        <div className="bigbox">
          <div className="overlap-9" style={{top:0}}>
            <div style = {{height: '100%'}}>
              <h3 style={{margin:0,paddingLeft: 38, paddingTop: 30, textAlign: 'left'}}>Stocks</h3>
            </div>
          </div>
        </div>

        
      </div>
        
  ) : (<div style={{width:'100vw', height: '100vh', position: 'static', left: '0px'}}><SignInPage/></div>)}
    </div>
  
  
  */}
  
  </div>
  
);

};

export default PortfolioDisplayPage;
